import { Component, OnInit } from '@angular/core';
import { CategoriesService } from 'src/app/services/categori.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup | any;

  constructor(private rest: CategoriesService, private route: Router) {}

  ngOnInit() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]),
      password: new FormControl('', [Validators.required]),
    });
  }

  login() {
    this.rest.showSpinner();
    let form = this.loginForm.value;
    if (this.loginForm.valid) {
      this.rest.login(form).subscribe(
        (res: any) => {
          this.rest.hideSpinner();
          this.rest.successToast('toast.login_success');
          localStorage.setItem('access_token', res.access_token);
          try {
            const payload = JSON.parse(atob(res.access_token.split('.')[1]));
            localStorage.setItem('is_admin', payload.is_admin ? 'true' : 'false');
            localStorage.setItem('is_super_admin', payload.is_super_admin ? 'true' : 'false');
          } catch {
            localStorage.setItem('is_admin', 'false');
            localStorage.setItem('is_super_admin', 'false');
          }
          this.route.navigateByUrl('/main');
        },
        (err: any) => {
          this.rest.hideSpinner();
          this.rest.errorToaster('toast.login_wrong_creds');
        }
      );
    }
  }
}
